import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Application from './Application';
import reportWebVitals from './reportWebVitals';

// Принудительно включаем компоненты в сборку
import AyahSearchStep from './pages/ArabicLessons/components/LessonSteps/AyahSearchStep';
import TajweedStep from './pages/ArabicLessons/components/LessonSteps/TajweedStep';
import RecognitionStep from './pages/ArabicLessons/components/LessonSteps/RecognitionStep';

// Экспортируем для предотвращения tree-shaking
export { AyahSearchStep, TajweedStep, RecognitionStep };

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Application />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

